import { Package, BasketItem } from '../types/basket';

export type DeliveryBadgeInfo = {
  packages: number;
  items: number;
  reduction: number;
  carrier?: string;
};

const getDiscount = (discount: number, item: BasketItem) => discount + item.discount.total;
const getItemsQuantity = (itemsQuantity: number, item: BasketItem) => itemsQuantity + item.quantity;
const getDeliveryBadgeInfo = ({ items, packages, reduction }: DeliveryBadgeInfo, pkg: Package) => ({
  items: items + pkg.items.reduce(getItemsQuantity, 0),
  packages: pkg.items.length ? packages + 1 : packages,
  reduction: reduction + pkg.items.reduce(getDiscount, 0),
});

export default getDeliveryBadgeInfo;
